<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
  <Col :span="12">
  <Card class="card-box">
    <div class="text-center" v-if="isShortHaulDeliveryVsEtaLoading">
      <Spinner />
    </div>
    <div class="status-msg" v-else-if="!dashboardConfigsDetails">
      <span>
        <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
        <p class="mt-0 ml-30">No data available</p>
      </span>
    </div>
    <Row :gutter="40" v-else>
      <Col :span="24">
      <div class="header-text">
        Delivery vs ETA - Short Haul
      </div>
      <Graph :graphDetail="dashboardConfigsGraphDetails" :headerConstant="etaBarChartConstants">
      </Graph>
      </Col>

      <Col :span="24">
      <Row :gutter="40" class="list-bordered divider col-pt-15 mt-30">
        <Col :span="12" v-for="header in deliveryVsEtaShortHaul" :key="header.id" :class="header.class">
        <Tooltip :open-delay="100" popper-class="max-width" effect="dark" placement="top">
          <div slot="content">
            <span v-html="getRangeData(header.type, header.column)"></span>
          </div>
          <ColCell :header="header" :value="dashboardConfigsDetails[header.column]"
            @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, type: header.type, header: $event })">
          </ColCell>
        </Tooltip>
        </Col>
      </Row>

      </Col>
    </Row>
  </Card>
  </Col>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import { cloneDeep } from 'lodash';
import Graph from '@/components/track/Graph';
import {
  etaDetailsHeaders,
  etaBarChartConstants,
  deliveryVsEtaShortHaul,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';


export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  data() {
    return {
      etaDetailsHeaders,
      etaBarChartConstants,
      deliveryVsEtaShortHaul,
      shortHaulDeliveryVsEta: null,
      isShortHaulDeliveryVsEtaLoading: true,
      fromToData: [],
    };
  },
  props: ['queryParams', 'dashboardConfigs', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  computed: {
    dashboardConfigsDetails() {
      const shortHaul =
        this.dashboardConfigs.widgets.short_haul_delivery_vs_eta;
      deliveryVsEtaShortHaul[0].description = shortHaul.early.range ? `Between ${shortHaul.early.from_hour} Hrs & ${shortHaul.early.to_hour} Hrs` : `Before ${shortHaul.early.from_hour} Hrs`;
      deliveryVsEtaShortHaul[1].description = shortHaul.on_time.range ? `Between ${shortHaul.on_time.from_hour} Hrs & ${shortHaul.on_time.to_hour} Hrs` : `Before ${shortHaul.on_time.from_hour} Hrs`;
      deliveryVsEtaShortHaul[2].description = shortHaul.late.range ? `Between ${shortHaul.late.from_hour} Hrs & ${shortHaul.late.to_hour} Hrs` : `More than ${shortHaul.late.from_hour} Hrs`;
      deliveryVsEtaShortHaul[3].description = shortHaul.very_late.range ? `Between ${shortHaul.very_late.from_hour} Hrs & ${shortHaul.very_late.to_hour} Hrs` : `More than ${shortHaul.very_late.from_hour} Hrs`;
      return this.shortHaulDeliveryVsEta;
    },
    dashboardConfigsGraphDetails() {
      const graphData = {
        early: this.shortHaulDeliveryVsEta.early,
        late: this.shortHaulDeliveryVsEta.late,
        onTime: this.shortHaulDeliveryVsEta.onTime,
        veryLate: this.shortHaulDeliveryVsEta.veryLate,
      };
      return graphData;
    },
  },
  methods: {
    async search() {
      const resultObj = 'shortHaulDeliveryVsEta';
      const loadingObj = 'isShortHaulDeliveryVsEtaLoading';
      const section = 'shortHaulDeliveryVsEta';
      const params = this.queryParams;
      this[loadingObj] = true;
      const result = await this.$store.dispatch('track/getDashboardDetails', {
        section,
        params,
      });
      if (result && !result.error) {
        this[resultObj] = result;
      } else {
        this[resultObj] = null;
      }
      this[loadingObj] = false;
    },
    getRangeData(type, column) {
      const shortHaul = this.dashboardConfigs.widgets.short_haul_delivery_vs_eta;
      this.fromToData[type] = shortHaul[type].range ?
        [shortHaul[type].from_hour, shortHaul[type].to_hour] : [shortHaul[type].from_hour];
      let processData = cloneDeep(this.trackingDashboard && this.trackingDashboard[`delivery${column}ShortHaul`]);
      this.fromToData[type].forEach((data, index) => {
        processData = processData.replaceAll(`{${index + 1}}`, data);
      });
      return processData;
    },
  },
};
</script>
